"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputEmail = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Input = require("../Input/Input");
var _excluded = ["label"];
/**
 * `InputEmail` provides mobile users with the appropriate keyboard for easy data entry.
 */
var InputEmail = function InputEmail(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Email address' : _ref$label,
    otherProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Input.Input, (0, _extends2.default)({
    label: label
  }, otherProps, {
    type: "email"
  }));
};
exports.InputEmail = InputEmail;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJJbnB1dEVtYWlsIiwibGFiZWwiLCJvdGhlclByb3BzIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvSW5wdXRFbWFpbC9JbnB1dEVtYWlsLnRzeCJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuXG5pbXBvcnQgeyBJbnB1dCwgSW5wdXRQcm9wcyB9IGZyb20gJy4uL0lucHV0L0lucHV0JztcblxuZXhwb3J0IHR5cGUgSW5wdXRFbWFpbFByb3BzID0gT21pdDxJbnB1dFByb3BzLCAndHlwZSc+O1xuXG4vKipcbiAqIGBJbnB1dEVtYWlsYCBwcm92aWRlcyBtb2JpbGUgdXNlcnMgd2l0aCB0aGUgYXBwcm9wcmlhdGUga2V5Ym9hcmQgZm9yIGVhc3kgZGF0YSBlbnRyeS5cbiAqL1xuZXhwb3J0IGNvbnN0IElucHV0RW1haWw6IFJlYWN0LkZDPElucHV0RW1haWxQcm9wcz4gPSAoe1xuICBsYWJlbCA9ICdFbWFpbCBhZGRyZXNzJyxcbiAgLi4ub3RoZXJQcm9wc1xufSkgPT4ge1xuICByZXR1cm4gPElucHV0IGxhYmVsPXtsYWJlbH0gey4uLm90aGVyUHJvcHN9IHR5cGU9XCJlbWFpbFwiIC8+O1xufTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7QUFFQTtBQUFtRDtBQUluRDtBQUNBO0FBQ0E7QUFDTyxJQUFNQSxVQUFxQyxHQUFHLFNBQXhDQSxVQUFxQyxPQUc1QztFQUFBLHNCQUZKQyxLQUFLO0lBQUxBLEtBQUssMkJBQUcsZUFBZTtJQUNwQkMsVUFBVTtFQUViLG9CQUFPLDZCQUFDLFlBQUs7SUFBQyxLQUFLLEVBQUVEO0VBQU0sR0FBS0MsVUFBVTtJQUFFLElBQUksRUFBQztFQUFPLEdBQUc7QUFDN0QsQ0FBQztBQUFDIn0=